import { RouteRecordRaw } from 'vue-router'

import { MODULE_DATEIEN_COLOR } from '@/modules/moduleConstants.ts'

const UnterlagenFreigabenList = () => import('@/modules/dateien/UnterlagenFreigabenList.vue')
const UnterlagenFreigabenForm = () => import('@/modules/dateien/UnterlagenFreigabenForm.vue')

const updateFormProps = (route) => {
  return {
    id: parseInt(route.params.id)
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/dateien/unterlagenfreigaben/',
    name: 'UnterlagenFreigabenList',
    component: UnterlagenFreigabenList,
    meta: {
      icon: 'mdi-share-variant-outline',
      color: MODULE_DATEIEN_COLOR
    }
  },
  // es gibt kein Add-Formular. Erstellung einer Freigabe erfolgt immer über das Objekt selbst.
  {
    path: '/dateien/unterlagenfreigaben/:id',
    name: 'UnterlagenFreigabenFormUpdate',
    component: UnterlagenFreigabenForm,
    props: updateFormProps,
    meta: {
      icon: 'mdi-share-variant-outline',
      color: MODULE_DATEIEN_COLOR
    }
  },
  {
    path: '/:modul/:model/:objectId/unterlagenfreigaben/add',
    name: 'UnterlagenFreigabenForm',
    component: UnterlagenFreigabenForm,
    props: true,
    meta: { icon: 'mdi-share-variant-outline', color: MODULE_DATEIEN_COLOR }
  }
]

export default routes